import { styled } from '@fluentui/react';
import { HierarchicalMultiSelectPickerBase } from './HierarchicalMultiSelectPicker.base';
import { getStyles } from './HierarchicalMultiSelectPicker.styles';

export const HierarchicalMultiSelectPicker = styled(HierarchicalMultiSelectPickerBase, getStyles, undefined, {
  scope: 'HierarchicalMultiSelectPicker',
});
